module.exports = __webpack_public_path__ + "img/C05TechAqueducts_ua.9cf2573f.webp";